import React, { ReactElement, useEffect } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import Layout from './Layout';
import routes from '../routing/routes';
import GlobalErrors from '../module/GlobalErrors';
import SecuredPage from '../module/SecuredPage';
import UserRole from '../model/currentuser/UserRole';
import PrispevokVestnikaUpdate from '../module/PrispevokVestnikaCreateUpdate/PrispevokVestnikaUpdate';
import usePrispevokVestnikaDetail from '../module/PrispevokVestnikaDetail/hook/usePrispevokVestnikaDetail';
import { isOwnVestnikOrganization } from '../function/permissions';
import { useUserContext } from '../context/UserContext';
import PageHeadingWithBackButton from '../module/PageHeadingWithBackButton';

const PrispevokVestnikaUpdatePage = (): ReactElement => {
  const {
    prispevokVestnikaDetail,
    prispevokVestnikaStatus,
  } = usePrispevokVestnikaDetail();

  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-title',
      title: 'Úprava príspevku vestníka',
    }, '*');
  }, []);

  const { pouzivatel } = useUserContext();

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.prispevokVestnika.list.to,
          heading: routes.prispevokVestnika.list.name,
        },
        {
          heading: `${prispevokVestnikaDetail?.cislo || 'Detail príspevku'}`,
          to: routes.prispevokVestnika.detail.withParams(prispevokVestnikaDetail?.uuid),
        },
        {
          to: routes.prispevokVestnika.update.withParams(prispevokVestnikaDetail?.uuid),
          heading: routes.prispevokVestnika.update.name,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={prispevokVestnikaStatus.loading}>
        <SecuredPage
          allowForRoles={[UserRole.REZORTNE_ZBIERKY_IMPORT, UserRole.REZORTNE_ZBIERKY_SPRAVCA]}
          additionalCheck={isOwnVestnikOrganization(pouzivatel, prispevokVestnikaDetail)}
          requestStatus={prispevokVestnikaStatus?.responseCode}
        >
          {prispevokVestnikaDetail && (
          <>
            <PageHeadingWithBackButton
              headingCaption="Úprava príspevku vestníka"
              backLinkText={`Späť na ${prispevokVestnikaDetail?.cislo}`}
              backLinkRoute={routes.prispevokVestnika.detail.withParams(prispevokVestnikaDetail?.uuid)}
            />
            <PrispevokVestnikaUpdate vestnikDetail={prispevokVestnikaDetail} />
          </>
          )}
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default PrispevokVestnikaUpdatePage;
